import { STORAGE_KEYS } from '@/config/storage_keys';

export const replaceRetailerInPath = (
  pathname: string,
  newId: string,
): string => {
  const parts = pathname.split('/');
  parts[1] = newId;
  return parts.join('/');
};

export const setSelectedRetailerId = (retailerId: string) => {
  localStorage.setItem(STORAGE_KEYS.SELECTED_RETAILER_ID, retailerId);
};

export const getSelectedRetailerId = () => {
  const selectedRetailerId = localStorage.getItem(
    STORAGE_KEYS.SELECTED_RETAILER_ID,
  );
  if (!selectedRetailerId) {
    return null;
  }
  return selectedRetailerId;
};
